const getTranslationInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    key: data?.key || "",
    en: data?.en || "", // EN-UK
    "en-us": data?.["en-us"] || "",
    de: data?.de || "",
    fr: data?.fr || "",
    es: data?.es || "",
    it: data?.it || "",
    pt: data?.pt || "",
    pl: data?.pl || "",
    nl: data?.nl || "",
    el: data?.el || "",
    tr: data?.tr || "",
    sv: data?.sv || "",
    ro: data?.ro || "",
  }
};

export default getTranslationInitialValues;
